import React, { useEffect, useState, useContext } from 'react';
import { Dialog,Backdrop, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, MenuItem, CircularProgress } from '@mui/material';
import { BlobClient, BlobServiceClient } from '@azure/storage-blob';
import { deleteFromCache, saveToCache, loadTitleCache, loadFromCacheBu } from './CacheHandler';
import { nanoid } from 'nanoid';
import { ModeContext } from './ModeContext';
import { decodeBase64UTF8, encodeBase64UTF8 } from './Codec';
import { SendToCosmos,LoadToCosmos } from './SendToCosmos';
import { AddAPhoto } from '@mui/icons-material';



const FileBUUploadModalNew = ({ open, onClose, fileData ,fileDataAll,type,onUpdated}) => {
  console.log('FileBUUploadModalNew',fileData)
//fileDataAll リストデータ全て


  const {  filebuList,setFilebuList, selectedFiles, setSelectedFiles, user } = useContext(ModeContext);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryValue, setCategoryValue] = useState('');
  const [tagValue, setTagValue] = useState('');
  const [filter1, setFilter1] = useState('');
  const [filter2, setFilter2] = useState('');
  const [filter3, setFilter3] = useState('');

  const [publicValue, setPublicValue] = useState('publish');
  const [viewFlag, setViewFlag] = useState('view');
  const [storedCompId, setStoredCompId] = useState('');
  const [compId, setCompId] = useState('');
  const [userId, setUserId] = useState('');

  // 公開/非公開の選択変更
  const handleChange = (event) => setPublicValue(event.target.value);
  const handleViewChange = (event) => setViewFlag(event.target.value);

  // 初期値設定
  useEffect(() => {
    setStoredCompId(localStorage.getItem('compId'));
    const comp = localStorage.getItem('compId');
    const userIdLocal = localStorage.getItem('userId');
    if (comp && userIdLocal) {
      setCompId(comp);
      setUserId(userIdLocal);
    }

//    loadTitleCache('chat-bufile-cache').then((data) => {
//      if (data) {
//        const grouped = {};
//        data.forEach((item) => {
//          const cat = item.messages?.category || '未分類';
//          if (!grouped[cat]) grouped[cat] = [];
//          grouped[cat].push(item);
//        });
//        setFilebuList({ [fileData?.buId]: grouped });
//      }
//    });
  }, [fileData?.buId, setFilebuList]);

  useEffect(() => {
    if (fileData) {
      setFilter1(fileData.filter1 || '');
      setFilter2(fileData.filter2 || '');
      setFilter3(fileData.filter3 || '');
      setPublicValue(fileData.public || 'publish');
      setViewFlag(fileData.viewFlag || 'view');

    }
  }, [fileData]);

  // ファイル選択
  const handleFileChange = (event) => {
    setSelectedFiles(Array.from(event.target.files));
  };


//更新
  const handleUpdate = async () => {
    if (filter1 === ''|| filter3 === '') {
        alert('未入力の箇所があります。');
      return;
    }

    const confirm = window.confirm('この保存しますか？');
    if (!confirm) return;
    const timestamp = Date.now();  // 現在のタイムスタンプをミリ秒単位で取得

    //if (selectedFiles.length === 0 || category === '') return;
    //const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}?${process.env.REACT_APP_BLOB_TOKEN}`;

    const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}/${fileData.id}?comp=metadata&${process.env.REACT_APP_BLOB_TOKEN}`;

    try {

      const headers = {
        "x-ms-version": "2020-10-02",
        "x-ms-date": new Date().toUTCString(),
        "x-ms-meta-uploadedBy": encodeBase64UTF8(user),
        "x-ms-meta-user": encodeBase64UTF8(fileData.title),
        "x-ms-meta-filename": encodeBase64UTF8(fileData.filename),
        "x-ms-meta-bu": encodeBase64UTF8(fileData.buId),      
        "x-ms-meta-filter1": encodeBase64UTF8(filter1),
        "x-ms-meta-filter2": encodeBase64UTF8(filter2),
        "x-ms-meta-filter3": filter3,
        "x-ms-meta-filter4": '',
        "x-ms-meta-filter5": 'u_doc',
        "x-ms-meta-status": publicValue,
        "x-ms-blob-type": "BlockBlob"
      };
      fetch(containerSasUrl, {
        method: "PUT",
        headers
      })
      .then(async (res)  => {
        if (res.ok)  {
          //cosmosdbの反映
          let uppayload ={}
          uppayload = { id: fileData.buId, container: 'con-concierge-filebunew' };
          const items = await LoadToCosmos(uppayload);

          const data={
            "id":fileData.buId,
            "category": filter1,
            "messages": [
                {
                    "id": fileData.id,
                    "filename":fileData.filename,
                    "url":fileData.url,
                    "filter1": filter1,
                    "filter2": filter2,
                    "filter3": filter3,
                    "filter5": 'u_doc',
                    "status":publicValue,
                    "timestamp":timestamp
                }
              ]
          }
          //UpdateCategory(items,data)
          const updData = addOrUpdateCategory(items,data)
          uppayload = {
            id: fileData.buId,
            messages: updData.item.messages,
            container: "con-concierge-filebunew"
          };

          await SendToCosmos(uppayload)

          if (onUpdated) {
            onUpdated();
          }

          alert('保存しました。');
          onClose();  
        } else {
          console.error("❌ エラーが発生:", res.statusText);
          alert('保存に失敗しました。');
        }
      })
    .catch(console.error);

          //await SendToCosmos(uppayload)      
    } catch (error) {
      console.error('アップロードエラー:', error);
    }
  };



//新規
  const handleUpload = async () => {
    if (selectedFiles.length === 0 || filter1 === ''|| filter3 === '') {
        alert('未入力の箇所があります。');
      return;
    }
    setIsLoading(true);

    const timestamp = Date.now();  // 現在のタイムスタンプをミリ秒単位で取得

    const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}?${process.env.REACT_APP_BLOB_TOKEN}`;

    try {
      //CosmosDBの情報を取得
      //const uppayload = { id: 'all', container: 'con-concierge-filebunew' };
      //const items = await LoadToCosmos(uppayload);
      //cosmosdbの取得して反映
      const uppayload = { id: fileData.buId, container: 'con-concierge-filebunew' };
      const items = await LoadToCosmos(uppayload);

      let metadata = {}
      // BlobServiceClient ではなく ContainerClient を直接作成
      const containerClient = new BlobServiceClient(containerSasUrl).getContainerClient('');

      const uploadPromises = selectedFiles.map(async (file) => {
        const uniqueId = nanoid();
        const blobName = `BU/${fileData.buId}/${uniqueId}-${file.name}`;
        const blockBlobClient = containerClient.getBlockBlobClient(blobName);

        //encodeBase64UTF8(original)

        metadata = {
          uploadedBy: user, // 例: ユーザーID
          user:storedCompId,
          filename: encodeBase64UTF8(file.name),
          bu:encodeBase64UTF8(fileData.buId),
          filter1:encodeBase64UTF8(filter1),
          filter2:encodeBase64UTF8(filter2),
          filter3:filter3,
          filter4:'',
          filter5:'u_doc',
          status:publicValue
        };

        const result = await blockBlobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type },
          metadata: metadata,
        });

        // result._response.status で HTTP ステータスを確認可能
        if (result._response.status >= 200 && result._response.status < 300) {

          console.log("アップロード成功",file.name);
          const data={
            "id":fileData.buId,
            "category": filter1,
            "messages": [
                {
                    "id": blobName,
                    "filename":file.name,
                    "url":blockBlobClient.url,
                    "filter1": filter1,
                    "filter2": filter2,
                    "filter3": filter3,
                    "filter5": 'u_doc',
                    "status":publicValue,
                    "timestamp":timestamp
                }
              ]
          }
          const addData=addOrUpdateCategory(items,data)
          //delete addData.id;
          const uppayload = {
            id: fileData.buId,
            messages: addData.item.messages,
            container: "con-concierge-filebunew"
          };
          await SendToCosmos(uppayload)

          onUpdated();//画面反映

          //await saveToCache(fileData.buId,'chat-bufilenew-cache',file.name ,uppayload,timestamp,'',''); // キャッシュに保存

        } else {
            console.warn("アップロードに問題があるかもしれません");
        }
    
      });
      
      await Promise.all(uploadPromises);
//      console.log('すべてのファイルがアップロードされました',merged);
      setSelectedFiles([]);
      //await cacheload();

      // フォーカスをリセットしてからモーダルを閉じる
      document.activeElement.blur();
      alert('保存完了しました。');
      onClose();
      
    } catch (error) {
      console.error('アップロードエラー:', error);
    }finally {
      setIsLoading(false);
    }

  };

  //ファイルリストの追加
  function addOrUpdateCategory(org_data,new_data) {
    const { id: buId, category: newCategory, messages } = new_data;
    const newMessage = messages[0];

    // category が存在するか確認
    let org_category = org_data.item.messages.find(cat => cat.category === newCategory);
    // category が無い → 新規作成
    if (!org_category) {
      org_category = {
        category: newCategory,
        messages: []
      };
      org_data.item.messages.push(org_category);
    }

    // 同じ ID の message があるか確認
    const msgIndex = org_category.messages.findIndex(m => m.id === newMessage.id);

    if (msgIndex >= 0) {
      // 更新
      org_category.messages[msgIndex] = {
        ...org_category.messages[msgIndex],
        ...newMessage
      };
    } else {
      // 追加
      org_category.messages.push(newMessage);
    }
    return org_data;
  }

// 削除
  const handleDelete = async (fileData) => {
    const confirm = window.confirm('このファイルを削除しますか？');
    if (!confirm) return;
    setIsLoading(true);
    
    try {
      //Blob削除
      const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}/${fileData.id}?${process.env.REACT_APP_BLOB_TOKEN}`;
      const blobClient = new BlobClient(containerSasUrl);
      await blobClient.delete();

      //CosmosDBのリスト削除
      const uppayload = { id: fileData.buId, container: 'con-concierge-filebunew' };
      const items = await LoadToCosmos(uppayload);
      const delData=delOrUpdateCategory(items,fileData)

      const delpayload = {
        id: fileData.buId,
        messages: delData.item.messages,
        container: "con-concierge-filebunew"
      };
      await SendToCosmos(delpayload)

      onUpdated();//画面反映

      //CosmosDBのファイルリストを削除
      alert('ファイルを削除しました。');
      onClose();

    } catch (err) {
      alert('ファイルを削除に失敗しました。');
      console.error("削除エラー:", err.message);
    }finally {
      setIsLoading(false);
    }

  };

  //ファイルリストの削除
  function delOrUpdateCategory(org_data,del_data) {
    if (org_data.item.id === del_data.buId) {
      org_data.item.messages = org_data.item.messages.map(categoryGroup => {
        if (categoryGroup.category === del_data.filter1) {
          return {
            ...categoryGroup,
            messages: categoryGroup.messages.filter(msg => msg.id !== del_data.id)
          };
        }
        return categoryGroup;
      }).filter(categoryGroup => categoryGroup.messages.length > 0);
    }
    
    return org_data
  }


  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose} // ローディング中は閉じさせない
      fullWidth
    >
      <DialogTitle>{fileData?.buId || "BU"}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mt: 2 }}>
          {fileData?.filename ? (
            <a 
              href={fileData.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: "#1976d2", textDecoration: "underline" }}
            >
              {fileData.filename}
            </a>
          ) : (
            ""
          )}
        </Typography>

        <TextField
          variant="outlined"
          fullWidth
          label="カテゴリー"
          margin="normal"
          value={filter1}
          onChange={(e) => setFilter1(e.target.value)}
          disabled={Boolean(fileData?.filename)} 
        />
        <TextField
          variant="outlined"
          fullWidth
          label="機種"
          margin="normal"
          value={filter2}
          onChange={(e) => setFilter2(e.target.value)}
        />
        <TextField
          variant="outlined"
          fullWidth
          label="グループ(半角英数)"
          margin="normal"
          value={filter3}
            onChange={(e) => {
            const value = e.target.value;
            // 半角英数字のみ
            if (/^[0-9A-Za-z]*$/.test(value)) {
              setFilter3(value);
            }}}
        />
        <TextField
          variant="outlined"
          fullWidth
          label="公開設定"
          margin="normal"
          value={publicValue}
          onChange={handleChange}
          select
        >
          <MenuItem value="publish">公開</MenuItem>
          <MenuItem value="private">非公開</MenuItem>
        </TextField>

        {!fileData?.filename && (
          <>
            <input
              type="file"
              multiple 
              onChange={handleFileChange}
            />

            <ul>
              {selectedFiles.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>
          </>
        )}
      </DialogContent>
      <Typography variant="caption" color="textSecondary" sx={{ display: "block", mt: 1 }}>
        ※「グループ」が検索キーになります。半角英数字で入力してください。
      </Typography>
      <DialogActions>
        <Button
          onClick={() => handleDelete(fileData)}
          color="primary"
          disabled={isLoading}
        >
          削除
        </Button>
        <Button
          onClick={() => {
            if (!fileData?.filename) {
              handleUpload();
            } else {
              handleUpdate(fileData);
            }
          }}
          color="primary" disabled={isLoading}>
          保存
        </Button>
        <Button onClick={onClose} color="secondary" disabled={isLoading}>
          キャンセル
        </Button>
      </DialogActions>

      {/* 保存中のローディング表示 */}
      <Backdrop open={isLoading} sx={{ color: "#fff", zIndex: 2000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default FileBUUploadModalNew;
